module.exports = __webpack_public_path__ + "static/img/snow2.7ebe573.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/snow2.jpg
// module id = b2He
// module chunks = 0